import isEmpty from "lodash-es/isEmpty";
import { Button, RemoveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useFilenameRules } from "../../hooks/inputFormats/useFilenameRules";

type BulkActionRemoveFilenameProps = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionRemoveFilenameRules: React.FC<
  BulkActionRemoveFilenameProps
> = ({ selectedRowKeys, setSelectedRowKeys }) => {
  const { t } = useTranslation();

  const { removeFilenameRules } = useFilenameRules();

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-remove"
      icon={<RemoveIcon />}
      onClick={() => {
        removeFilenameRules(selectedRowKeys.map(Number));

        setSelectedRowKeys([]);
      }}
    >
      {t("inputFormats.actions.filenameRules.list.actions.remove.button")}
    </Button>
  );
};
